export const ReviewReply = {
  bindings: {
    data: '<',
    isUser: '<',
    onLike: '&',
    onReply: '&',
    onShowReplies: '&',
  },

  template: `
    <div class="review-reply d-flex py-3" ng-class="{ 'bg-green-pale': $ctrl.data.highlight }">
      <div class="review-avatar mr-3">
        <image-circle src="$ctrl.data.member.avatarUrl.thumb"></image-circle>
      </div>
      <div class="review-body">
        <h5>{{ $ctrl.data.member.screenName }}</h5>
        <div class="review-content pb-3" ng-bind-html="$ctrl.data.review"></div>
        <div class="pb-2" ng-show="$ctrl.data.rating">
          <rating-stars rating="$ctrl.data.rating"></rating-stars>
        </div>
        <div class="review-options">
          <spinner is-loading="$ctrl.data.isLoading"></spinner>
          <button class="btn-link plain"
            ng-click="$ctrl.onShowReplies({ reviewId: $ctrl.data.id })"
            ng-show="$ctrl.data.repliesCount > 0">
            {{ $ctrl.data.repliesCount }}
            <span ng-show="$ctrl.data.repliesCount > 1">replies</span>
            <span ng-show="$ctrl.data.repliesCount == 1">reply</span>
          </button>
          <button class="btn-link plain"
            ng-click="$ctrl.onLike({ reviewId: $ctrl.data.id })"
            ng-hide="$ctrl.isUser">
            Like
          </button>
          <button class="btn-link plain"
            ng-click="$ctrl.onReply()">
            Reply
          </button>
          <span class="meta"
            ng-show="$ctrl.data.liked">
            {{ $ctrl.data.likesCount }}
            like<span ng-show="$ctrl.data.likesCount > 1">s</span>
          </span>
          <span class="meta">
            {{ $ctrl.data.createdAt | daysElapsed }}
          </span>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Review/ReviewReply.js